import React, { useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useGetActiveStatusQuery } from "../../Slices/usersApiSlice";
import { useParams } from "react-router-dom";

interface CircleButtonProps {
  isPayee: boolean;
  canPayout: boolean;
  allPaid?: boolean;
  status: string;
  onDeposit: () => void;
  onWithdraw: () => void;
  loading: boolean;
}

function CircleButton({
  onDeposit,
  onWithdraw,
  isPayee,
  allPaid,
  canPayout,
  status,
  loading,
}: CircleButtonProps) {
  const [action] = React.useState<string>(isPayee ? "Withdraw" : "Deposit");

  const isButtonDisabled = () => {
    if (isPayee) {
      return !(canPayout && allPaid);
    }

    // Disable if already paid or payment is processing (ACSS bank debits)
    return status === "Paid" || status === "Processing";
  };

  const handleClick = () => {
    switch (action) {
      case "Deposit":
        onDeposit();
        break;
      case "Withdraw":
        onWithdraw();
        break;
      default:
        console.warn(`Unhandled action: ${action}`);
    }
  };

  return (
    <Button
      disabled={isButtonDisabled()}
      onClick={handleClick}
      sx={{
        width: { xs: "100%", sm: 350 },
        height: 40,
        backgroundColor: "primary.main",
        borderRadius: "10px",
      }}
      variant="contained"
    >
      {loading ? <CircularProgress color="info" size={30} /> : action}
    </Button>
  );
}

export default CircleButton;
